<template>
  <v-app>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th v-for="header in headers" :key="header.text" class="text-left">{{header.text}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.ID">
            <td>{{order.id}}</td>
            <td>{{order.clientFIO}}</td>
            <td>{{order.clientPhone}}</td>
            <td class="date">{{order.date}}</td>
            <td>{{order.comment}}</td>
            <td>
                <a @click.prevent="onclicked(order.id)" style=" text-decoration: none" class="mr-2" color="white">Подробнее</a>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-app>
</template>
<script>
import axios from "axios";
import orderService from '../api-services/order.service';

export default {
  name: "OrderList",
  data() {
    return {
      orders: [],
      headers: [
        {
          text: "ID клиента",
          aligh: "start",
          value: "ID",
        },
        { text: "ФИО клиента", value: "ClientFIO" },
        { text: "Телефон клиента", value: "ClientPhone" },
        { text: "Дата размещения", value: "Date" },
        { text: "Комментарий", value: "Comment" },
        { text: "Подробности", value: "Podr" },
      ],
    };
  },
  methods: {
    onclicked(orderid){
        this.$router.push({name: 'Order',params: {id: orderid}});
    }
  },
  mounted() {
    orderService.getAll();
    /*axios.get("https://practiqe.somee.com/api/order").then((response) => {
      this.orders = response.data;
      console.log(response);
    });*/
  },
  function(value) {
    var obr = document.querySelector(".date");
    obr = obr.innerHTML.replace("/(d+).(d+).(d+)", "$1.$2.$3");
  },
};
</script>